const filterChipTypeVariants = {
    chip: {},
    tile: {}
};
const filterChipTypes = Object.keys(filterChipTypeVariants);
const filterChipSlots = {
    containerSlot: 'focus-visible:ring-2 focus-visible:ring-primary-8 flex items-center border border-solid px-2 py-[1px] rounded-action-sm focus-visible:outline-none focus-visible:ring-offset-2 hover:cursor-pointer hover:aria-pressed:cursor-pointer transition-all duration-150 ease-in-out',
    iconLeftSlot: '',
    checkIconSlot: '',
    iconRightSlot: '',
    labelTextSlot: 'p-1 whitespace-nowrap text-body2 text-left',
    countSlot: 'pr-1 text-body3 ml-auto',
    checkboxSlot: 'hidden',
    helperTextSlot: 'text-body3 p-1 pt-0 text-left',
    faviconSlot: 'h-[18px] w-[18px]',
    faviconImg: 'rounded-xsm',
    labelImageSlot: 'max-h-4 max-w-24',
    chipRangeSlot: ''
};
const filterChipDefaultVariants = {
    emphasis: 'regular',
    type: 'chip'
};
export { filterChipDefaultVariants, filterChipSlots, filterChipTypeVariants, filterChipTypes };
